import { gql, useQuery } from '@apollo/client'
import _ from 'lodash'
import moment from 'moment'
import { useMemo } from 'react'

import { useDateFilter } from '../../../../dateFilter'
import { useGroupFilter } from '../../../../groupFilter'
import { useVariables } from '../../../../variables'
import { IApiDataType } from '../../../types'

interface IDataType {
  getLocationTopMissingItems: {
    nodes: {
      itemName: string
      totalCount: string
    }[]
  }
}

const query = gql`
  query topMissingItems($iEndDate: Date!, $iStartDate: Date!, $iFilter: JSON!) {
    getLocationTopMissingItems(
      iStartDate: $iStartDate
      iEndDate: $iEndDate
      iFilter: $iFilter
    ) {
      nodes {
        itemName
        totalCount
      }
    }
  }
`

export const bbbMissingItemConfigs = {
  itemName: 'string',
  totalCount: 'number',
} as const

const YESTERDAY = moment().subtract(1, 'day')

const useBbbMissingItem = () => {
  const { variables } = useVariables()
  const { startDate, endDate: filterEndDate } = useDateFilter()
  const { groupFilter } = useGroupFilter()
  const endDate = useMemo(
    () =>
      moment(filterEndDate, 'YYYY-MM-DD').isAfter(YESTERDAY)
        ? YESTERDAY.format('YYYY-MM-DD')
        : filterEndDate,
    [filterEndDate],
  )
  const { data, loading } = useQuery<IDataType>(query, {
    variables: {
      iStartDate: startDate,
      iEndDate: endDate,
      iFilter: variables.corporateGroup
        ? {
            location_group_ids: groupFilter?.ids,
          }
        : {
            location_ids: groupFilter?.ids,
          },
    },
    skip: !startDate || !endDate || !groupFilter,
  })

  return {
    data: useMemo((): IApiDataType => {
      const missingItem = data?.getLocationTopMissingItems.nodes

      if (!missingItem) return null

      return missingItem.map((d) => ({
        ...d,
        id: d.itemName,
        parentId: 'root',
        totalCount: parseFloat(d.totalCount),
      }))
    }, [data]),
    loading,
  }
}

export default useBbbMissingItem
